// this logic provides search results for www.fastly.com
// both www and docs results are returned
import { useCallback, useEffect, useState } from "react"

import debounce from "lodash.debounce"

export enum FetchStatus {
  Idle,
  Pending,
  Fulfilled,
  Errored,
}

const BASE_URL = "https://api.fastly.com/public-search/marketing"
const MAX_RESULTS = 25
const DEBOUNCE_INTERVAL = 300


type PageRecord = {
  title: string
  id: string
  body: string
  url: string
}

export function useUnisearch(searchQuery = "") {
  const [results, setResults] = useState<PageRecord[] | null>(null)
  const [status, setStatus] = useState(FetchStatus.Idle)

  const url = new URL(BASE_URL)
  url.searchParams.append("query", searchQuery)
  url.searchParams.append("limit", String(MAX_RESULTS))

  const fetchResults = useCallback(
    debounce(() => {
      fetch(url, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      })
        .then((res) => res.json())
        .then((json) => {
          if (json.records) {
            setStatus(FetchStatus.Fulfilled)
            setResults(json.records as PageRecord[])
          }
        })
        .catch(() => {
          setStatus(FetchStatus.Errored)
          setResults(null)
        })
    }, DEBOUNCE_INTERVAL),
    [searchQuery, setStatus, setResults],
  )

  useEffect(() => {
    if (searchQuery?.length >= 3) {
      setStatus(FetchStatus.Pending)

      fetchResults()
    } else {
      setStatus(FetchStatus.Idle)
      setResults(null)
    }

    return () => {
      fetchResults.cancel()
    }
  }, [searchQuery, fetchResults])

  return { results, status }
}
